import styled from "styled-components";

export const OtaUpdatesWrapper = styled.div`
  .header {
    text-align: center;
    margin-bottom: 20px;
  }
  .limits-warning {
    background: #fff3cd;
    border: 1px solid #ffe69c;
    color: #664d03;
    border-radius: 6px;
    padding: 10px 14px;
    margin: 8px 0 16px;
  }
  .mono {
    font-family: "Consolas", "Menlo", monospace;
    font-size: 12px;
    word-break: break-all;
  }
  .muted {
    color: #6c757d;
    font-size: 13px;
  }
  .file-row td {
    vertical-align: middle;
  }
  .live-row {
    background: #f4f7ff;
  }
  .status-live {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    background: #d1f2df;
    color: #0f6b3a;
    font-weight: 700;
    font-size: 13px;
  }
  .status-archived {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    background: #e9ecef;
    color: #495057;
    font-weight: 700;
    font-size: 13px;
  }
  .actions-col {
    min-width: 240px;
  }
  .action-btns {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }
  .action-btns button {
    text-transform: none;
    font-weight: 500;
    white-space: nowrap;
  }
  .copy-link {
    cursor: pointer;
    color: #607afc;
    text-decoration: underline;
  }
  .filter-select {
    padding: 6px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
  }
  .history-filter {
    display: flex;
    align-items: center;
    gap: 8px;
    input {
      padding: 5px 8px;
      width: 140px;
    }
  }
  .form-group {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }
  .form-group label {
    width: 45%;
    font-size: 16px;
    font-weight: 700;
  }
  .form-group input {
    padding: 5px;
    width: 55%;
  }
  .form-hint {
    font-size: 12px;
    color: #6c757d;
    margin: -6px 0 10px 45%;
  }
  .buttons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-top: 30px;
    justify-content: end;
    button {
      min-width: 100px;
    }
  }
`;
